import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 获取列表
export const getBill = params => {
  return axios.request({
    url: "/finance/bill",
    method: "get",
    params
  });
};
// 创建列表
export const add = data => {
  return axios.request({
    url: "/finance/bill",
    data,
    method: "post"
  });
};
// 获取详情
export const getDetails = params => {
  return axios.request({
    url: `/finance/bill/${params.id}`,
    method: "GET",
    params
  });
};
// 更新列表
export const update = data => {
  return axios.request({
    url: `/finance/bill/${data.id}`,
    method: "put",
    data
  });
};

// 删除列表
export const del = id => {
  return axios.request({
    url: `/finance/bill/${id}`,
    method: "DELETE"
  });
};

// 可以结账用户
export const getBillClient = params => {
  return axios.request({
    url: "/finance/bill/query",
    method: "get",
    params
  });
};

// 月结用户
export const getMonthUsers = () => {
  return axios.request({
    url: "/finance/bill/getMonthUsers",
    method: "get"
  });
};

// 月结用户
export const createMonthUserBill = data => {
  return axios.request({
    url: "/finance/bill/createMonthUserBill",
    method: "post",
    data
  });
};

// 重新计算金额
export const resetAmount = id => {
  return axios.request({
    url: `/finance/bill/resetAmount/${id}`,
    method: "post"
  });
};

// 账单审核
export const postAudit = data => {
  return axios.request({
    url: `/finance/bill/audit/${data.id}`,
    method: "post",
    data
  });
};

// 账单确认
export const postConfirm = id => {
  return axios.request({
    url: `/finance/bill/confirm/${id}`,
    method: "post"
  });
};

export const exportBill = id => {
  return axios.request({
    url: `/finance/orderfinance/exportFinance/${id}`,
    method: "get"
  });
};

export const updateFreight = (id, data) => {
  return axios.request({
    url: `/finance/bill/setFreightAppend/${id}`,
    method: "post",
    data
  });
};

export const getConfig = () => {
  return axios.request({
    url: `/finance/bill/config`,
    method: "get"
  });
};

export const addFreight = data => {
  return axios.request({
    url: `/finance/bill/addBatchExtendFee/${data.id}/${data.fid}`,
    method: "post",
    data
  });
};

export const getFreight = params => {
  return axios.request({
    url: `/finance/bill/getBatchExtendFee/${params.id}/${params.fid}`,
    method: "get"
  });
};

export const hangBill = data => {
  return axios.request({
    url: `/finance/bill/removeDetail/${data.id}`,
    method: "post",
    data
  });
};

export const updateBill = data => {
  return axios.request({
    url: `/finance/bill/${data.id}`,
    method: "put",
    data
  });
};

export function uploadBillFlie(id, data) {
  return axios.request({
    url: `/finance/orderfinance/uploadExtExcel/${id}`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken()
    },
    data: data
  });
}

export function exportUpload(id) {
  return axios.request({
    url: `/finance/orderfinance/exportFinance/${id}`,
    method: "post"
  });
}

export function getExtFiles(id) {
  return axios.request({
    url: `/finance/orderfinance/getExtFiles/${id}`,
    method: "get"
  });
}

export function addExtFiles(data) {
  return axios.request({
    url: `/finance/orderfinance/saveExtFiles/${data.id}`,
    method: "post",
    data
  });
}

export function getUsdRate() {
  return axios.request({
    url: `/finance/bill/dollarRate`,
    method: "get"
  });
}

export function ConversionUsd(data) {
  return axios.request({
    url: `/finance/bill/trans/${data.id}`,
    method: "post",
    data
  });
}

export function deleteFile(id) {
  return axios.request({
    url: `/finance/orderfinance/deleteFile/${id}`,
    method: "delete"
  });
}

export function exportMonthBill(data) {
  return axios.request({
    url: `/finance/bill/exportMerge`,
    method: "post",
    data
  });
}

export function exportAllBill(data) {
  return axios.request({
    url: `/finance/bill_analyze/sp_bill/export`,
    method: "post",
    data
  });
}

export function getOperator() {
  return axios.request({
    url: `/finance/bill/operator`,
    method: "get"
  });
}

export function previewEmail(params) {
  return axios.request({
    url: `/plugin/reviewBillEmail`,
    method: "get",
    params
  });
}

export function deleteDetails(data) {
  return axios.request({
    url: `/finance/bill/deleteOut/${data.id}`,
    method: "post",
    data
  });
}

export function cancelClientOff(id) {
  return axios.request({
    url: `/finance/bill/cancelOff/${id}`,
    method: "post"
  });
}

export const appendCnbNo = data => {
  return axios.request({
    url: `/finance/bill/append/${data.id}`,
    method: "post",
    data
  });
};

export const addBranchFreight = data => {
  return axios.request({
    url: `/finance/bill/batchSetOtherFee/${data.id}`,
    method: "post",
    data
  });
};

export const xbDoHedge = data => {
  return axios.request({
    url: `/finance/hedge/xbDoHedge`,
    method: "post",
    data
  });
};

export const changeBillHeader = data => {
  return axios.request({
    url: `/finance/bill/changeBillHeader`,
    method: "post",
    data
  });
};

